import { toast } from "react-toastify";

import {
  fetchDashboardFailure,
  fetchDashboardStart,
  fetchDashboardSuccess,
} from "./reducer";
import { getDashboarDataService } from "../../Services/DashboardService";

export const fetchDashboardDataList = () => async (dispatch) => {
  try {
    dispatch(fetchDashboardStart());
    const response = await getDashboarDataService();

    if (response?.success) {
      dispatch(
        fetchDashboardSuccess({
          dashboardData: response.data,
        }),
      );
    } else {
      dispatch(fetchDashboardFailure("No data found"));
    }
  } catch (error) {
    toast.error(error || "Something went wrong");

    dispatch(fetchDashboardFailure(error));
  }
};
